/**
 * Logo animation  
 */ 

// Let .logo-animated complete its animation even if mouse leaves mid-animation
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.logo-animated').forEach(logo => {
    logo.addEventListener('mouseenter', () => {
      clearTimeout(logo._animTimeout);
      logo.classList.add('animate');
    });
    logo.addEventListener('mouseleave', () => {
      logo._animTimeout = setTimeout(() => logo.classList.remove('animate'), 1750);
    });
  });
});
